var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { createUIElement } from "./";
import { SelectableNumberInputField } from './SelectableNumberInputField';
import { StackView, STACK_DIRECTION, STACK_GAP } from "../StackView";
import { Radiobutton } from "../controls/Radiobutton";
export var generateSelectableTextInputData = function (minValue, maxValue, is12Hours, isIgnored) {
    var data = [];
    if (is12Hours) {
        data.push('12');
    }
    for (var value = minValue; value <= maxValue; value++) {
        if ((isIgnored === null || isIgnored === void 0 ? void 0 : isIgnored(value)) || (is12Hours && value === 12)) {
            continue;
        }
        data.push("" + value);
    }
    return data;
};
var DEFAULT_TEXTS = {
    hours: 'Hours:',
    minutes: 'Minutes:',
    am: 'AM',
    pm: 'PM',
    errorHoursRequiredText: 'Please select a hours',
    errorMinutesRequiredText: 'Please select a minutes'
};
export var dataSelectorId = {
    main: 'timeselector'
};
export var TimeSelector = createUIElement('TimeSelector', function (_a, ref) {
    var className = _a.className, is12Hours = _a.is12Hours, hours = _a.hours, minutes = _a.minutes, onHoursChange = _a.onHoursChange, onMinutesChange = _a.onMinutesChange, onPeriodChange = _a.onPeriodChange, isAmTimePeriod = _a.isAmTimePeriod, texts = _a.texts, errorHours = _a.errorHours, errorMinutes = _a.errorMinutes, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "is12Hours", "hours", "minutes", "onHoursChange", "onMinutesChange", "onPeriodChange", "isAmTimePeriod", "texts", "errorHours", "errorMinutes", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var uiTexts = __assign({ hours: DEFAULT_TEXTS.hours, minutes: DEFAULT_TEXTS.minutes, am: DEFAULT_TEXTS.am, pm: DEFAULT_TEXTS.pm, errorHoursRequiredText: DEFAULT_TEXTS.errorHoursRequiredText, errorMinutesRequiredText: DEFAULT_TEXTS.errorMinutesRequiredText }, texts);
    var minHours = is12Hours ? 1 : 0;
    var maxHours = is12Hours ? 12 : 23;
    return (React.createElement(StackView, __assign({}, rest, { testId: rest['data-selector-id'] || dataSelectorId.main, className: "vm-TimeSelector " + className, direction: STACK_DIRECTION.column, gap: STACK_GAP.s, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        React.createElement(StackView, { gap: STACK_GAP.m },
            React.createElement(SelectableNumberInputField, { label: uiTexts.hours, errorText: errorHours ? uiTexts.errorHoursRequiredText : '', error: !!errorHours, data: generateSelectableTextInputData(minHours, maxHours, is12Hours), minValue: minHours, maxValue: maxHours, value: hours, onChange: onHoursChange }),
            React.createElement(SelectableNumberInputField, { label: uiTexts.minutes, errorText: errorMinutes ? uiTexts.errorMinutesRequiredText : '', error: !!errorMinutes, data: generateSelectableTextInputData(0, 59, false, function (value) { return value % 5 !== 0; }), minValue: 0, maxValue: 59, value: minutes, onChange: onMinutesChange })),
        is12Hours && (React.createElement(Radiobutton, { value: true, checked: isAmTimePeriod, onChange: onPeriodChange }, uiTexts.am)),
        is12Hours && (React.createElement(Radiobutton, { value: false, checked: !isAmTimePeriod, onChange: onPeriodChange }, uiTexts.pm))));
});
//# sourceMappingURL=TimeSelector.js.map